import { render, staticRenderFns } from "./CoralsolLocalidadeTable.vue?vue&type=template&id=20bac00e&"
import script from "./CoralsolLocalidadeTable.vue?vue&type=script&lang=js&"
export * from "./CoralsolLocalidadeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports